module.exports = __webpack_public_path__ + "static/media/medpal_lineal_white.51e9486c.svg";